<template>
  <div class="order-step">
    <next-prev-menu
      :previous="false"
      title="Naar Bezorgen"
      @next-step="$router.push({ name: 'printOrderDeliver' })"
    ></next-prev-menu>
    <product-order-cart :standalone="false" :secure="secure"></product-order-cart>
  </div>
</template>

<script>
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import ProductOrderCart from '@/features/productOrder/ProductOrderCart.vue'
import { mapStores } from 'pinia'
import { usePrintOrderStore } from '@/features/printOrder/PrintOrder.store'

export default {
  name: 'CartV2',
  components: {
    NextPrevMenu,
    ProductOrderCart
  },

  data() {
    return {}
  },

  computed: {
    ...mapStores(usePrintOrderStore),
    // Uit de store lezen (niet uit de route-query), zodat de secured-modus
    // bewaard blijft bij stappen terug vanuit Bezorgen/Factureren/Controleren.
    secure() {
      return this.printOrderStore.orderDetails.secure
    }
  },
  methods: {}
}
</script>

<style scoped></style>
